// Stable per-dataset colour. Each dataset id maps deterministically to one of a
// fixed palette of Mantine colour names, so the same dataset always gets the
// same colour everywhere it's shown (the recommended-strategy chips and the cart
// chips). Brand green is omitted so dataset chips stay distinct from the brand /
// reach accents.
export const DATASET_COLORS = [
    'blue',
    'grape',
    'teal',
    'orange',
    'cyan',
    'pink',
    'indigo',
    'violet',
] as const

// Hash the id into the palette (same dataset → same colour, across cards).
export const colorForDataset = (key: string): string => {
    let h = 0
    for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) | 0
    return DATASET_COLORS[Math.abs(h) % DATASET_COLORS.length]
}
